if (!customElements.get('nopa-main-product')) {
  const nopaMoney = (cents) => {
    try {
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  };

  const nopaAddItems = async (items) => {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart'); }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      const cartRes = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
      drawer.renderContents({ sections: await cartRes.json() });
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  };

  const nopaEscapeHtml = (str) => String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const nopaWalkRichNode = (node) => {
    if (!node) return '';
    if (Array.isArray(node)) return node.map(nopaWalkRichNode).join('');
    switch (node.type) {
      case 'root':
        return nopaWalkRichNode(node.children);
      case 'paragraph': {
        const inner = nopaWalkRichNode(node.children);
        return inner.trim() ? `<p>${inner}</p>` : '';
      }
      case 'heading': {
        const level = node.level || 2;
        return `<h${level}>${nopaWalkRichNode(node.children)}</h${level}>`;
      }
      case 'list': {
        const tag = node.listType === 'ordered' ? 'ol' : 'ul';
        return `<${tag}>${nopaWalkRichNode(node.children)}</${tag}>`;
      }
      case 'list-item':
        return `<li>${nopaWalkRichNode(node.children)}</li>`;
      case 'text': {
        let t = nopaEscapeHtml(node.value || '');
        if (node.bold) t = `<strong>${t}</strong>`;
        if (node.italic) t = `<em>${t}</em>`;
        return t;
      }
      default:
        return node.children ? nopaWalkRichNode(node.children) : '';
    }
  };

  const nopaParseFauxRichText = (raw) => {
    if (!raw) return null;
    const trimmed = raw.trim();
    if (!/^\{\s*"type"\s*=>\s*"root"/.test(trimmed)) return null;
    try {
      const json = trimmed.replace(/=>/g, ':');
      const data = JSON.parse(json);
      const html = nopaWalkRichNode(data);
      return html || null;
    } catch (e) {
      return null;
    }
  };

  const nopaFixRichTextBlocks = (root) => {
    (root || document).querySelectorAll('[data-nopa-richfix]').forEach((el) => {
      if (el.dataset.richfixed === 'true') return;
      const raw = el.textContent;
      const html = nopaParseFauxRichText(raw);
      if (html) {
        el.innerHTML = html;
      }
      el.dataset.richfixed = 'true';
    });
  };

  class NopaMainProduct extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-nopa-product]');
      this.data = dataEl ? JSON.parse(dataEl.textContent) : null;
      this.selected = {};
      this.activeIndex = 0;
      if (this.data) {
        (this.data.options || []).forEach((opt, i) => { this.selected[i] = this.data.initial_options[i]; });
        this.bindOptions();
        this.updateVariant(false);
      }
      this.bindAtc();
      this.initVideos();
      this.initLightbox();
      this.initStage();
      this.initBundle();
      this.initSingleAdds();
      this.initSizeGuide();
      this.recordRecentlyViewed();
      nopaFixRichTextBlocks(this);
    }

    bindOptions() {
      this.querySelectorAll('[data-option-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.selected[Number(btn.dataset.optionIndex)] = btn.dataset.value;
          this.updateVariant(true);
        });
      });
    }

    currentVariant() {
      return (this.data.variants || []).find((v) =>
        v.options.every((val, i) => val === this.selected[i])
      );
    }

    updateVariant(userAction) {
      this.querySelectorAll('[data-option-index]').forEach((btn) => {
        const i = Number(btn.dataset.optionIndex);
        btn.classList.toggle('is-selected', this.selected[i] === btn.dataset.value);
        const hypothetical = { ...this.selected, [i]: btn.dataset.value };
        const match = (this.data.variants || []).find((v) => v.options.every((val, j) => val === hypothetical[j]));
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });
      const v = this.currentVariant();
      const priceEl = this.querySelector('[data-price]');
      const compareEl = this.querySelector('[data-compare]');
      const idInput = this.querySelector('[data-variant-id]');
      const atc = this.querySelector('[data-atc]');
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = atc.dataset.labelUnavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      }
      const bundleMainPrice = this.querySelector('[data-bundle-main-price]');
      if (bundleMainPrice) { bundleMainPrice.dataset.cents = v.cents; bundleMainPrice.textContent = v.price; this.updateBundleTotal(); }
      if (userAction && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    bindAtc() {
      const atc = this.querySelector('[data-atc]');
      const idInput = this.querySelector('[data-variant-id]');
      const errEl = this.querySelector('[data-atc-error]');
      if (!atc || !idInput) return;
      atc.addEventListener('click', async (e) => {
        e.preventDefault();
        atc.classList.add('is-loading');
        errEl && errEl.classList.remove('is-visible');
        try {
          await nopaAddItems([{ id: Number(idInput.value), quantity: 1 }]);
        } catch (err) {
          if (errEl) { errEl.textContent = err.message; errEl.classList.add('is-visible'); }
        } finally {
          atc.classList.remove('is-loading');
        }
      });
    }

    initStage() {
      const track = this.querySelector('[data-nopa-gallery]');
      if (!track) return;
      const slides = [...track.children];
      const thumbs = [...this.querySelectorAll('.nopa-mp__thumb')];
      const prev = this.querySelector('[data-gal-prev]');
      const next = this.querySelector('[data-gal-next]');
      const zoomBtn = this.querySelector('[data-gal-zoom]');

      // Adaptive frame: match the gallery frame to the active image's true
      // aspect ratio, so every image fills without cropping or letterboxing.
      const applyRatio = (i) => {
        const el = slides[i] && slides[i].querySelector('img, video');
        if (!el) return;
        const w = el.naturalWidth || el.videoWidth;
        const h = el.naturalHeight || el.videoHeight;
        if (w && h) {
          this.style.setProperty('--active-ratio', w + ' / ' + h);
        } else if (el.tagName === 'IMG') {
          el.addEventListener('load', () => {
            if (this.activeIndex === i && el.naturalWidth) {
              this.style.setProperty('--active-ratio', el.naturalWidth + ' / ' + el.naturalHeight);
            }
          }, { once: true });
        }
      };

      const setActive = (i) => {
        this.activeIndex = i;
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        if (prev) prev.toggleAttribute('disabled', i <= 0);
        if (next) next.toggleAttribute('disabled', i >= slides.length - 1);
        applyRatio(i);
      };
      setActive(0);

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          setActive(slides.indexOf(e.target));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach((s) => io.observe(s));

      // Robust fallback: update the active slide (and adaptive frame) on any
      // horizontal scroll/swipe, in case the observer misses fast swipes.
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const w = track.clientWidth || 1;
          const i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
          if (i !== this.activeIndex) setActive(i);
          else applyRatio(i);
        }, 60);
      }, { passive: true });

      const goTo = (i) => {
        const clamped = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
      };
      prev && prev.addEventListener('click', () => goTo(this.activeIndex - 1));
      next && next.addEventListener('click', () => goTo(this.activeIndex + 1));
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      zoomBtn && zoomBtn.addEventListener('click', () => this.openLightbox && this.openLightbox(this.activeIndex));

      this.addEventListener('keydown', (e) => {
        if (e.target.closest('.nopa-lightbox')) return;
        if (e.key === 'ArrowLeft') goTo(this.activeIndex - 1);
        if (e.key === 'ArrowRight') goTo(this.activeIndex + 1);
      });
    }

    initBundle() {
      const wrap = this.querySelector('[data-bundle]');
      if (!wrap) return;
      wrap.querySelectorAll('[data-bundle-check]').forEach((c) => c.addEventListener('change', () => this.updateBundleTotal()));
      this.updateBundleTotal();
      const btn = wrap.querySelector('[data-bundle-add]');
      if (btn) {
        // Reuse a dedicated error element if the template provides one,
        // otherwise create a lightweight one so failures are never silent.
        let errEl = wrap.querySelector('[data-bundle-error]');
        if (!errEl) {
          errEl = document.createElement('div');
          errEl.setAttribute('data-bundle-error', '');
          errEl.className = 'nopa-mp__bundle-error';
          errEl.style.display = 'none';
          errEl.style.color = '#c0392b';
          errEl.style.marginTop = '8px';
          errEl.style.fontSize = '0.9em';
          btn.insertAdjacentElement('afterend', errEl);
        }
        btn.addEventListener('click', async () => {
          const items = [];
          wrap.querySelectorAll('[data-bundle-check]:checked').forEach((c) => {
            const id = c.dataset.main === 'true' ? Number(this.querySelector('[data-variant-id]').value) : Number(c.dataset.variantId);
            if (id) items.push({ id, quantity: 1 });
          });
          if (!items.length) return;
          btn.classList.add('is-loading');
          errEl.style.display = 'none';
          try {
            await nopaAddItems(items);
          } catch (err) {
            errEl.textContent = err.message || 'Could not add all items to cart.';
            errEl.style.display = 'block';
          } finally {
            btn.classList.remove('is-loading');
          }
        });
      }
    }

    updateBundleTotal() {
      const wrap = this.querySelector('[data-bundle]');
      if (!wrap) return;
      let total = 0;
      wrap.querySelectorAll('[data-bundle-check]:checked').forEach((c) => {
        const row = c.closest('.nopa-mp__bundle-row');
        const priceEl = row && row.querySelector('[data-cents], [data-bundle-main-price]');
        if (priceEl) total += Number(priceEl.dataset.cents || 0);
      });
      const totalEl = wrap.querySelector('[data-bundle-total]');
      if (totalEl) totalEl.textContent = nopaMoney(total);
    }

    initSingleAdds() {
      this.querySelectorAll('[data-add-variant]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          btn.classList.add('is-loading');
          try { await nopaAddItems([{ id: Number(btn.dataset.addVariant), quantity: 1 }]); } catch (e) {} finally { btn.classList.remove('is-loading'); }
        });
      });
    }

    initSizeGuide() {
      const drawer = this.querySelector('.nopa-sg-drawer');
      const openBtn = this.querySelector('[data-sg-open]');
      if (!drawer || !openBtn) return;
      const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
      openBtn.addEventListener('click', (e) => { e.preventDefault(); drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
      drawer.querySelectorAll('[data-sg-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }

    initVideos() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          e.intersectionRatio >= 0.5 ? v.play().catch(() => {}) : v.pause();
        });
      }, { threshold: [0, 0.5] });
      this.querySelectorAll('[data-nopa-gallery-video]').forEach((v) => io.observe(v));
    }

    initLightbox() {
      if (this.dataset.zoom !== 'true') return;
      const lb = this.querySelector('.nopa-lightbox');
      if (!lb) return;
      const stage = lb.querySelector('[data-lb-stage]');
      const medias = [...this.querySelectorAll('.nopa-mp__media')];
      let idx = 0;
      const show = (i) => {
        idx = (i + medias.length) % medias.length;
        const img = medias[idx].querySelector('img');
        const vid = medias[idx].querySelector('video');
        stage.innerHTML = '';
        if (vid) {
          const clone = vid.cloneNode(true);
          clone.controls = true; clone.muted = false; clone.removeAttribute('data-nopa-gallery-video');
          stage.appendChild(clone);
        } else if (img) {
          const big = document.createElement('img');
          big.src = img.currentSrc || img.src;
          big.alt = img.alt || '';
          stage.appendChild(big);
        }
      };
      const open = (i) => { show(i); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
      const close = () => { lb.classList.remove('is-open'); stage.innerHTML = ''; document.body.style.overflow = ''; };
      this.openLightbox = open;
      medias.forEach((m, i) => {
        m.addEventListener('click', (e) => {
          if (e.target.closest('.nopa-mp__heart') || e.target.closest('model-viewer') || e.target.closest('iframe')) return;
          open(i);
        });
      });
      lb.querySelector('[data-lb-close]').addEventListener('click', close);
      lb.querySelector('[data-lb-prev]').addEventListener('click', () => show(idx - 1));
      lb.querySelector('[data-lb-next]').addEventListener('click', () => show(idx + 1));
      lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
      document.addEventListener('keydown', (e) => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    }

    recordRecentlyViewed() {
      const handle = this.dataset.handle;
      if (!handle) return;
      try {
        const KEY = 'nopa:recent';
        let list = JSON.parse(localStorage.getItem(KEY)) || [];
        list = [handle, ...list.filter((h) => h !== handle)].slice(0, 12);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    }
  }
  customElements.define('nopa-main-product', NopaMainProduct);
}